import { render, staticRenderFns } from "./EmployeeBottomNav.vue?vue&type=template&id=698acaea"
import script from "./EmployeeBottomNav.vue?vue&type=script&lang=js"
export * from "./EmployeeBottomNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('698acaea')) {
      api.createRecord('698acaea', component.options)
    } else {
      api.reload('698acaea', component.options)
    }
    module.hot.accept("./EmployeeBottomNav.vue?vue&type=template&id=698acaea", function () {
      api.rerender('698acaea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmployeeBottomNav.vue"
export default component.exports